import Vue from 'vue'
import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    dataItems: {},
  },
  getters: {
    dataItem: state => id => state.dataItems[id] || {},
  },
  mutations: {
    SET_DATA_ITEM(state, { id, data }) {
      Vue.set(state.dataItems, id, data)
    },
  },
  actions: {
    getDataItem({ commit }, id) {
      axiosIns
        .post('/contents', { id })
        .then(response => {
          commit('SET_DATA_ITEM', { id, data: response.data.data })
        })
        .catch(error => console.error(error))
    },
  },
}
